/*
auto-generated by: https://github.com/react-spring/gltfjsx
*/

import * as THREE from 'three';
import React, { useRef, useState, useEffect } from 'react';
import { useLoader, useFrame } from 'react-three-fiber';
import { GLTFLoader, GLTF } from 'three/examples/jsm/loaders/GLTFLoader';
// import { SkeletonUtils } from 'three/examples/jsm/utils/SkeletonUtils';

type Props = {
  model: 'Male_Walk_01' | 'Male_Walk_02' | 'Male_Walk_03' | 'Female_Walk_01';
  number: number;
  originalPosX: number;
  originalPathX: number;
  pathX: number;
  originalPosY: number;
  originalPathY: number;
  pathY: number;

}

type GLTFResult = GLTF & {
  nodes: {
    Male_LowPoly_v001Male_LoPoly: THREE.SkinnedMesh
    QuickRigCharacter_Hips: THREE.Bone
  }
  materials: {
    Male_glTF: THREE.MeshStandardMaterial
  },
  clone: () => any,
}

type ActionName = 'Walkcycle_01';
type GLTFActions = Record<ActionName, THREE.AnimationAction>;

export default function Model(props: Props & JSX.IntrinsicElements['group']) {
  const group = useRef<THREE.Group>();
  const meshRef = useRef<THREE.Mesh>();
  const model = useLoader<GLTFResult>(GLTFLoader, `/assets/Male/${props.model}.glb?number=${props.number}`);
  const speed = 0.04;

  useFrame(() => {
    if (meshRef.current) {
      const position = meshRef.current.position;

      if (position.x > props.pathX && position.z >= props.originalPathY) {
        meshRef.current.rotation.y = 0;
        meshRef.current.position.x -= speed;
        meshRef.current.position.z = props.originalPathY;
      } else if (position.x <= props.pathX && position.z >= props.pathY) {
        
        meshRef.current.rotation.y = -Math.PI/2;
        // meshRef.current.position.x -= speed;
        meshRef.current.position.z -= speed;
        
        // setRotation(-Math.PI/2);
        // setPosition({ x: position.x, y: position.y - speed });
      }
      else if (position.z <= props.pathY && position.x <= props.originalPathX) {
        meshRef.current.rotation.y = Math.PI;
        meshRef.current.position.x += speed;
        meshRef.current.position.z = props.pathY;
  
        // setRotation(Math.PI);
        // setPosition({ x: position.x + speed, y: props.pathY });
      }
      else if (position.x >= props.originalPathX) {
        meshRef.current.rotation.y = Math.PI/2;
        meshRef.current.position.x = props.originalPathX;
        meshRef.current.position.z += speed;
  
        // setRotation(Math.PI/2);
        // setPosition({ x: props.originalPathX, y: position.y + speed });
      }
    }
    
  });

  // const clonedScene = useMemo(() => SkeletonUtils.clone(model.scene), [model]) as THREE.Group;
  // const clonedModel = clonedScene.children[2] as THREE.SkinnedMesh;

  const actions = useRef<GLTFActions>();
  const [mixer] = useState(() => new THREE.AnimationMixer(model.nodes.Male_LowPoly_v001Male_LoPoly));

  useFrame((state, delta) => mixer.update(delta));
  useEffect(() => {
    actions.current = {
      // Crouch_01: mixer.clipAction(model.animations[0], group.current),
      // Idle_01: mixer.clipAction(model.animations[1], group.current),
      Walkcycle_01: mixer.clipAction(model.animations[0], group.current),
    }

    actions.current.Walkcycle_01.play()

    return () => model.animations.forEach((clip) => mixer.uncacheClip(clip))
  }, [model.animations, mixer]);

  return (
    <group
      ref={meshRef}
      name={`Character Male 1/${props.number}`}
      position={[props.originalPosX, 0, props.originalPosY]}
      scale={[5, 5, 5]}
    >
      <group ref={group} {...props} dispose={null}>
        <group rotation={[0, -1.57, 0]}>
          <primitive object={model.nodes.QuickRigCharacter_Hips} />
        </group>
        <skinnedMesh
          castShadow
          material={model.materials.Male_glTF}
          geometry={model.nodes.Male_LowPoly_v001Male_LoPoly.geometry}
          skeleton={model.nodes.Male_LowPoly_v001Male_LoPoly.skeleton}
        />
      </group>
    </group>
  );
}
